"use strict";

require("core-js/modules/es6.promise");


//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/lib/core-js/modules/es6.promise.js
// module id = 19
// module chunks = 0